import Page from "../../layouts/Page";
import messages from '@super-template/messages';
import {FormattedMessage} from 'react-intl';
import {makeStyles, Paper, Typography} from "@material-ui/core";
import BackButton from "@super-template/core/src/BackButton";
import {useParams} from "react-router-dom";
import NotFound from "@super-template/core/src/NotFound";

export const path = '/:organization/accessibility_statement';
export const exact = true;

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    '& h2, h3': {
      fontFamily: theme.typography.bold,
    },
    '& h2': {
      marginBottom: theme.spacing(5)
    },
    '& h3': {
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(2)

    },
    '& p': {
      marginBottom: theme.spacing(2)
    }
  },
  info: {
    marginBottom: theme.spacing(4),
    '& p': {
      marginBottom: theme.spacing(0.5)
    }
  }
}));

const organizationName = {
  MTLH: 'Maaseudun Terveys- ja Lomahuolto ry',
  NASYLOMAT: 'Naiset Yhdessä ry',
  SOLARISLOM: 'Solaris-lomat ry',
  HYVINVOINT: 'Hyvinvointilomat ry',
  SEMESTER: 'Svenska Semesterförbundet',
  PHT: 'Palkansaajien hyvinvointi ja terveys PHT ry',
  PHTPERHE: 'Palkansaajien hyvinvointi ja terveys PHT ry'
};
const organizationEmail = {
  MTLH: 'lomat@mtlh.fi',
  NASYLOMAT: 'toimisto@nasylomat.fi',
  SOLARISLOM: 'solaris@solaris-lomat.fi',
  HYVINVOINT:'toimisto@hyvinvointilomat.fi',
  SEMESTER: 'susanna.stenman@folkhalsan.fi',
  PHT: 'asiakaspalvelu@pht.fi',
  PHTPERHE: 'asiakaspalvelu@pht.fi'
};
const organizationPhone = {
  MTLH: '010 2193 460',
  NASYLOMAT: '040 55 04 557',
  HYVINVOINT: '010 830 3400',
  PHT: '020 1441310',
  PHTPERHE: '020 1441310'
};
const organizationLink = {
  MTLH: 'https://link.webropolsurveys.com/S/2F90042873B805B0',
  HYVINVOINT:'https://link.webropolsurveys.com/S/B622FF6F935571CA'
};

const getContent = (organization) => ({
  name: organizationName[organization],
  email: organizationEmail[organization],
  phone: organizationPhone[organization],
  link: organizationLink[organization]
});

export const component = function AccessibilityStatement() {
  const classes = useStyles();
  const {organization} = useParams();
  const content = getContent(organization);

  return (content.name ?
      <Page title={<FormattedMessage {...messages.accessibility_statement} />}>
        <Paper className={classes.root}>
          <Typography variant="h5" component="h2" className={classes.title}>
            <FormattedMessage {...messages.accessibility_welcome} values={{org: content.name}}/>
          </Typography>
          <Typography variant="body1"><FormattedMessage {...messages.accessibility_info} /></Typography>
          <Typography variant="body1"><FormattedMessage {...messages.accessibility_by} /></Typography>
          <Typography variant="h5" component="h3"><FormattedMessage {...messages.accessibility_tested} /></Typography>
          <Typography variant="body1"><FormattedMessage {...messages.accessibility_result} /></Typography>
          <Typography variant="h5" component="h3">
            <FormattedMessage {...messages.accessibility_deficiency} /><br/>
            <FormattedMessage {...messages.accessibility_deficiency_inform} />
          </Typography>
          {content.link &&
          <div>
            <Typography variant="h6" component="h4"><FormattedMessage {...messages.accessibility_form} /></Typography>
            <Typography variant="body1">
              <a href={"https://link.webropolsurveys.com/S/2F90042873B805B0"} target={"_blank"} rel="noreferrer">
                <FormattedMessage {...messages.accessibility_form_fill} />
              </a>
            </Typography>
          </div>}
          {content.email &&
          <div>
            <Typography variant="h6" component="h4"><FormattedMessage {...messages.accessibility_email} /></Typography>
            <Typography variant="body1"><a href={`mailto:${content.email}`}>{content.email}</a></Typography>
          </div>}
          {content.phone &&
          <div>
            <Typography variant="h6" component="h4"><FormattedMessage {...messages.accessibility_phone} /></Typography>
            <Typography variant="body1">{content.phone}</Typography>
          </div>}
          <Typography variant="h5" component="h3"><FormattedMessage {...messages.accessibility_official} /></Typography>
          <Typography variant="body1">
            <FormattedMessage {...messages.accessibility_official_info} />{' '}
            <a href={"https://www.saavutettavuusvaatimukset.fi/kayttajan-oikeudet/"} target={"_blank"} rel="noreferrer">
              <FormattedMessage {...messages.accessibility_official_name} />
            </a>{' '}
            <FormattedMessage {...messages.accessibility_official_info2} />
          </Typography>
          <div className={classes.info}>
            <Typography variant="h5" component="h3">
              <FormattedMessage {...messages.accessibility_official_contact} />
            </Typography>
            <Typography variant="body2"><FormattedMessage {...messages.accessibility_official_org} /></Typography>
            <Typography variant="body2"><FormattedMessage {...messages.accessibility_official_unit} /></Typography>
            <Typography variant="body2">
              <a href={"https://www.saavutettavuusvaatimukset.fi/"} target={"_blank"} rel="noreferrer">
                www.saavutettavuusvaatimukset.fi
              </a>
            </Typography>
            <Typography variant="body2">saavutettavuus(at)avi.fi</Typography>
            <Typography variant="body2"><FormattedMessage {...messages.accessibility_official_phone} /></Typography>
          </div>
          <BackButton variant="contained" color="primary"/>
        </Paper>
      </Page> : <NotFound/>
  );
};
